/**
 * Create a new array where the element at `from` index is moved to `to` index.
 *
 * _Holes will be normalized to_ `undefined`.
 *
 * @throws Error when either `from` or `to` index is out of bounds.
 */
export const moveArrayElement = <T>(
  array: T[],
  from: number,
  to: number,
): T[] => {
  if (from < 0 || from >= array.length) {
    throw new Error(`Index ${from} is out of bounds`);
  }

  if (to < 0 || to >= array.length) {
    throw new Error(`Index ${to} is out of bounds`);
  }

  // As we don't expect holes in the array, we assert that the item exists.
  const item = array[from]!;
  const result = [...array];

  result.splice(from, 1);
  result.splice(to, 0, item);
  return result;
};
